module.exports = __webpack_public_path__ + "static/media/smile.man.e18ef35d.png";